import { find, forEach, isEmpty } from 'lodash';

export const findPathByKey = (
  data: API.MenuItem[] = [],
  pathname = location.pathname,
) => {
  if (isEmpty(find(data, { key: '/' }))) {
    data = [
      {
        key: '/',
        label: '首页',
      },
      ...data,
    ];
  }
  const result: {
    key?: string;
    label: React.ReactNode;
    query?: string;
    disabled?: boolean;
  }[] = [];
  // 递归查找路径
  const findPath = (
    node: API.MenuItem,
    list: { key?: string; label: React.ReactNode }[] = [
      {
        key: '/',
        label: '首页',
      },
    ],
  ) => {
    if (isEmpty(node)) return;
    const regex = new RegExp(
      `^${node.key?.replace(/:\w+/g, '\\w+').replace('*', '.*')}$`,
    );
    if (regex.test(pathname)) {
      // 找到目标节点
      if (node.key === '/') {
        result.push(node);
      } else {
        result.push(...list, { ...node });
      }
      return result;
    } else {
      if (!isEmpty(node.children)) {
        // 遍历子节点
        forEach(node.children, child => {
          const newList = [...list, { label: node.label, query: node.query }];
          findPath(child, newList);
        });
      }
    }
  };

  forEach(data, node => {
    findPath(node);
  });

  // 返回路径数组
  return result;
};
